const MembershipResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'memberships/',
        apiRequestParams.defaults(),
        {
            update: {
                method: 'PUT',
                url: appConfig.apiBaseUrl + 'memberships/:membershipID',
            },
            updateMultiple: {
                method: 'PUT',
                isArray: true,
                url: appConfig.apiBaseUrl + 'memberships',
            },
            cancelMultiple: {
                method: 'DELETE',
                isArray: true,
                url: appConfig.apiBaseUrl + 'memberships',
            },
            getRefunds: {
                method: 'GET',
                url: appConfig.apiBaseUrl + 'membershiprefundamounts',
            },
        }
    );
};

module.exports = MembershipResource;
